window.WishlistManager = {
  WISHLIST_KEY: 'zuboc_wishlist',
  RECENTLY_VIEWED_KEY: 'zuboc_recently_viewed',

  parseHTML(htmlString) {
    return Array.from(new DOMParser().parseFromString(htmlString, 'text/html').body.childNodes);
  },

  init() {
    console.log('WishlistManager Initialized!');
    this.injectStyles();
    this.updateWishlistUI();
    this.setupEventListeners();
  },

  injectStyles() {
    if (!document.getElementById('wishlist-styles')) {
      const style = document.createElement('style');
      style.id = 'wishlist-styles';
      style.textContent = `
        .wishlist-btn.wishlist-active {
          background-color: #4a4145 !important;
          color: white !important;
          border-color: #4a4145 !important;
        }
        .wishlist-btn.wishlist-active svg {
          fill: currentColor;
        }
      `;
      document.head.appendChild(style);
    }
  },

  getWishlist() {
    const data = localStorage.getItem(this.WISHLIST_KEY);
    return data ? JSON.parse(data) : [];
  },

  getRecentlyViewed() {
    const data = localStorage.getItem(this.RECENTLY_VIEWED_KEY);
    return data ? JSON.parse(data) : [];
  },

  saveWishlist(wishlist) {
    localStorage.setItem(this.WISHLIST_KEY, JSON.stringify(wishlist));
    this.updateWishlistUI();
  },

  saveRecentlyViewed(recentlyViewed) {
    localStorage.setItem(this.RECENTLY_VIEWED_KEY, JSON.stringify(recentlyViewed));
  },

  toggleWishlist(handle) {
    console.log('Toggling wishlist for:', handle);
    let wishlist = this.getWishlist();
    if (wishlist.includes(handle)) {
      wishlist = wishlist.filter(h => h !== handle);
      console.log('Removed from wishlist');
    } else {
      wishlist.push(handle);
      console.log('Added to wishlist');
    }
    this.saveWishlist(wishlist);
    
    // If we are on the wishlist page and an item is removed, re-render or hide it
    if (window.location.pathname.includes('/pages/wishlist')) {
      const card = document.querySelector(`.wishlist-grid-item[data-handle="${handle}"]`);
      if (card) {
        card.remove();
        this.checkEmptyWishlist();
      }
    }
  },

  updateWishlistUI() {
    const wishlist = this.getWishlist();
    const buttons = document.querySelectorAll('.wishlist-btn');
    
    buttons.forEach(btn => {
      const handle = btn.getAttribute('data-product-handle');
      if (wishlist.includes(handle)) {
        btn.classList.add('wishlist-active');
      } else {
        btn.classList.remove('wishlist-active');
      }
    });

    // Update header count badges
    const badges = document.querySelectorAll('.wishlist-count-badge');
    badges.forEach(badge => {
      if (wishlist.length > 0) {
        badge.textContent = wishlist.length;
        badge.classList.remove('hidden');
      } else {
        badge.textContent = '0';
        badge.classList.add('hidden');
      }
    });
  },

  setupEventListeners() {
    console.log('Setting up wishlist event listeners');
    document.addEventListener('click', (e) => {
      const btn = e.target.closest('.wishlist-btn');
      if (btn) {
        console.log('Wishlist button clicked', btn);
        e.preventDefault();
        e.stopPropagation();
        const handle = btn.getAttribute('data-product-handle');
        if (handle) {
          this.toggleWishlist(handle);
        } else {
          console.error('No product handle found on button', btn);
        }
      }
    });
  },

  trackProductView(handle) {
    if (!handle) return;
    let viewed = this.getRecentlyViewed();
    // Remove if already exists so we can push to top
    viewed = viewed.filter(h => h !== handle);
    viewed.unshift(handle);
    // Keep only last 10
    if (viewed.length > 10) {
      viewed.pop();
    }
    this.saveRecentlyViewed(viewed);
  },

  async fetchAndRenderProducts(handles, containerElementId, emptyMessageElementId) {
    const container = document.getElementById(containerElementId);
    const emptyMsg = document.getElementById(emptyMessageElementId);
    
    if (!container) return;

    if (!handles || handles.length === 0) {
      container.replaceChildren();
      if (emptyMsg) emptyMsg.classList.remove('hidden');
      return;
    }

    if (emptyMsg) emptyMsg.classList.add('hidden');
    container.replaceChildren(...this.parseHTML('<div class="w-full text-center py-10"><div class="inline-block animate-spin rounded-full h-8 w-8 border-t-2 border-b-2 border-gray-900"></div></div>'));

    // Fetch in batches or promise all
    try {
      const fetchPromises = handles.map(handle => 
        fetch(`/search?q=handle:${handle}&type=product&view=card`).then(res => res.text())
      );
      
      const htmlResponses = await Promise.all(fetchPromises);
      
      container.replaceChildren();
      htmlResponses.forEach((html, index) => {
        if (html.trim() !== '') {
          const div = document.createElement('div');
          div.className = 'wishlist-grid-item w-full';
          div.setAttribute('data-handle', handles[index]);
          // For wishlist page we might want to pass a param to show the X. 
          // Since we can't pass params dynamically via search view easily, 
          // we will modify the button locally via JS for wishlist page.
          div.replaceChildren(...this.parseHTML(html));
          
          if (containerElementId === 'wishlist-grid') {
            const btn = div.querySelector('.wishlist-btn');
            if (btn) {
               btn.setAttribute('data-is-wishlist-page', 'true');
               btn.replaceChildren(...this.parseHTML(`<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><line x1="18" y1="6" x2="6" y2="18"></line><line x1="6" y1="6" x2="18" y2="18"></line></svg>`));
               btn.classList.add('bg-white', 'text-gray-400', 'hover:text-red-500');
               btn.classList.remove('bg-[#4a4145]', 'text-white');
            }
          }

          container.appendChild(div);
        }
      });

      this.updateWishlistUI();

    } catch (error) {
      console.error('Error fetching products:', error);
      container.replaceChildren(...this.parseHTML('<p class="text-center text-red-500">Failed to load products.</p>'));
    }
  },

  checkEmptyWishlist() {
    const grid = document.getElementById('wishlist-grid');
    const emptyMsg = document.getElementById('wishlist-empty-msg');
    if (grid && emptyMsg) {
      if (grid.children.length === 0) {
        emptyMsg.classList.remove('hidden');
      } else {
        emptyMsg.classList.add('hidden');
      }
    }
  }
};

document.addEventListener('DOMContentLoaded', () => {
  window.WishlistManager.init();
});

// Initialize Product Carousels globally (using event delegation so it works for dynamically added product cards)
if (!window.ProductCarouselInitialized) {
  window.ProductCarouselInitialized = true;

  function getCarouselCard(element) {
    return element.closest('.product-card-wrapper, .env-product-card');
  }

  function getCarouselIndex(container) {
    var width = container.clientWidth || 1;
    return Math.round(container.scrollLeft / width);
  }

  function updateCarouselUI(container) {
    var card = getCarouselCard(container);
    if (!card) return;

    var dots = card.querySelectorAll('.dot');
    var prevBtn = card.querySelector('.carousel-prev');
    var nextBtn = card.querySelector('.carousel-next');
    var scrollWidth = container.clientWidth || 1;
    var index = getCarouselIndex(container);
    var maxIndex = dots.length ? dots.length - 1 : Math.max(container.children.length - 1, 0);

    if (dots.length) {
      dots.forEach(function(dot, i) {
        if (i === index) {
          dot.className = 'dot rounded-full transition-all duration-300 w-5 h-2 bg-[#333]';
        } else {
          dot.className = 'dot rounded-full transition-all duration-300 w-2 h-2 bg-gray-300 hover:bg-gray-400';
        }
      });
    }

    if (prevBtn) {
      prevBtn.classList.toggle('hidden', index === 0);
    }
    if (nextBtn) {
      nextBtn.classList.toggle('hidden', index >= maxIndex);
    }
  }

  document.addEventListener('click', function(e) {
    var prevBtn = e.target.closest('.carousel-prev');
    var nextBtn = e.target.closest('.carousel-next');
    var dotBtn = e.target.closest('.dot');

    if (prevBtn || nextBtn || dotBtn) {
      e.preventDefault();
      e.stopPropagation();

      var card = getCarouselCard(prevBtn || nextBtn || dotBtn);
      if (!card) return;

      var container = card.querySelector('.carousel-container');
      if (!container) return;

      var scrollWidth = container.clientWidth;

      if (prevBtn) {
        container.scrollBy({ left: -scrollWidth, behavior: 'smooth' });
      } else if (nextBtn) {
        container.scrollBy({ left: scrollWidth, behavior: 'smooth' });
      } else if (dotBtn) {
        var index = parseInt(dotBtn.getAttribute('data-index') || '0', 10);
        container.scrollTo({ left: scrollWidth * index, behavior: 'smooth' });
      }

      window.requestAnimationFrame(function() {
        updateCarouselUI(container);
      });
    }
  });

  document.addEventListener('scroll', function(e) {
    if (e.target && e.target.classList && e.target.classList.contains('carousel-container')) {
      updateCarouselUI(e.target);
    }
  }, true);

  document.addEventListener('mouseover', function(e) {
    var card = getCarouselCard(e.target);
    if (!card || card.classList.contains('env-swatch-active')) return;
    var related = e.relatedTarget;
    if (related && card.contains(related)) return;

    var container = card.querySelector('.carousel-container');
    if (!container || container.children.length < 2) return;

    var scrollWidth = container.clientWidth;
    if (!scrollWidth) return;

    container.scrollTo({ left: scrollWidth, behavior: 'smooth' });
  });

  document.addEventListener('mouseout', function(e) {
    var card = getCarouselCard(e.target);
    if (!card || card.classList.contains('env-swatch-active')) return;
    var related = e.relatedTarget;
    if (related && card.contains(related)) return;

    var container = card.querySelector('.carousel-container');
    if (!container || container.children.length < 2) return;

    container.scrollTo({ left: 0, behavior: 'smooth' });
  });

  document.querySelectorAll('.carousel-container').forEach(function(container) {
    updateCarouselUI(container);
  });
}
